import { PropsWithChildren, memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { PropsWithClassName } from '../../props';

type GlowTextsProps = PropsWithChildren &
    PropsWithClassName & {
        TagName?: keyof HTMLElementTagNameMap;
    };

export const GlowTexts: ComponentMemo<GlowTextsProps> = memo(({ children, className, TagName = 'p' }) => {
    return <TagName className={clsx('whitespace-pre-wrap', className)}>{children}</TagName>;
});

GlowTexts.displayName = 'GlowTexts';
